import { useState, useEffect } from "react";
import "./BrowseProduct.css";
import axiosInstance from "../../../Config/axiosInstance";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { Button } from "@mui/material";
import { Box } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

function BrowseProduct({ onClose, onSelectProducts }) {
  const [selected, setSelected] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [products, setProducts] = useState([]);
  const [sortAsc, setSortAsc] = useState(true);

  useEffect(() => {
    axiosInstance
      .get("/product/")
      .then((response) => {
        setProducts(response.data);
      })
      .catch((error) => {
        console.error("Eroare la incarcarea produselor: ", error);
      });
  }, []);

  const toggleProduct = (product) => {
    setSelected((prev) => {
      const newSelected = [...prev];
      if (newSelected.includes(product)) {
        newSelected.splice(newSelected.indexOf(product), 1);
      } else {
        newSelected.push(product);
      }
      return newSelected;
    });
  };

  const handleSort = () => {
    const sorted = [...products].sort((a, b) =>
      sortAsc ? a.title.localeCompare(b.title) : b.title.localeCompare(a.title)
    );
    setProducts(sorted);
    setSortAsc(!sortAsc);
  };

  const handleExport = () => {
    const adaptedProducts = selected.map(prod => ({
      id: prod.id,
      productId: prod.id,
      title: prod.title,
      quantity: '',
      um: '',
      vat: '',
      cost: '',
      tax_id: '',
      total: ''
    }));

    console.log("Produse exportate:", adaptedProducts);
    onSelectProducts(adaptedProducts);
    onClose();
  };

  //filtrare produse active
  const activeProducts = products.filter(product => product.status === "ACTIVE")
  const filteredProducts = activeProducts.filter((p) =>
    p.title?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="browse-product">
      <div className="overlay">
        <div className="modal">
          <h3>Select products to export</h3>

          <Box className="search-bar-container">
            <Box className="search-input-wrapper">
              <SearchIcon sx={{ color: "#888", marginRight: "-15px" }} />
              <input
                type="text"
                placeholder="Search products"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </Box>

            <Button
              variant="outlined"
              startIcon={sortAsc ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
              onClick={handleSort}
              className="filter-button"
            >
              Filter
            </Button>
          </Box>

          <label>Available products</label>
          <hr />
          <ul className="product-list">
            {filteredProducts.map((product) => (
              <li key={product.id}>
                <label>
                  <input
                    type="checkbox"
                    checked={selected.includes(product)}
                    onChange={() => toggleProduct(product)}
                  />
                  {" "}
                  {product.title}
                </label>
              </li>
            ))}
          </ul>
          <hr />

          <div className="actions">
            <Button variant="contained" onClick={onClose} sx={{ backgroundColor: "grey.500" }}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleExport} sx={{ backgroundColor: "green.600" }}>
              Done
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BrowseProduct;